import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../shared/api/api.tokens';
import { REQUIRE_AUTH } from '../shared/interceptors/auth-context';

export interface DashboardMetricsResponse {
  today: TodayMetrics;
  week: WeekMetrics;
  upcomingEvents: UpcomingEventDto[];
  sales: SalesSummary;
}

export interface TodayMetrics {
  totalAppointments: number;
  completedAppointments: number;
  pendingAppointments: number;
  cancelledAppointments: number;
}

export interface WeekMetrics {
  totalAppointments: number;
  completedAppointments: number;
  pendingAppointments: number;
  cancelledAppointments: number;
  occupancyPercentage: number | null;
}

export interface UpcomingEventDto {
  eventId: string;
  clientId: string;
  clientName: string;
  clientPhone: string;
  clientEmail: string | null;
  startDate: string;
  endDate: string;
  serviceName: string;
  statusName: string;
  statusCode: string;
  paymentCompleted: boolean;
  finalPrice: number | null;
}

export interface SalesSummary {
  todayTotal: number;
  weekTotal: number;
  todayCount: number;
  weekCount: number;
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  getMetrics(): Observable<DashboardMetricsResponse> {
    return this.http.get<DashboardMetricsResponse>(
      `${this.baseUrl}/api/v1/dashboard/metrics`,
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }
}
